import { render, staticRenderFns } from "./PendingOrderList.vue?vue&type=template&id=3c3bc576&scoped=true&"
import script from "./PendingOrderList.vue?vue&type=script&lang=js&"
export * from "./PendingOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PendingOrderList.vue?vue&type=style&index=0&id=3c3bc576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3bc576",
  null
  
)

export default component.exports